export const muscleGroupSection = {
  color: 'rgba(255, 255, 255, 0.6)',
};

export const titleBarStyle = { margin: 0, justifyContent: 'flex-end' };
